export default {
  sm: `
  인터넷의 보급, 이동통신의 발달,
  스마트폰의 등장과 같은 새로운 기술의
  출현은 사람들이 더욱 많은 데이터를 만들고
  소비하게 합니다. 데이터는 이제 우리 일상을
  채우는 공기 같은 존재가 되었습니다.
  `,
  lg: `
  인터넷의 보급, 이동통신의 발달, 스마트폰의 등장과 같은 새로운
  기술의 출현은 사람들이 더욱 많은 데이터를 만들고 소비하게 합니다.
  데이터는 이제 우리 일상을 채우는 공기 같은 존재가 되었습니다.
  `,
  xxl: `
  인터넷의 보급, 이동통신의 발달, 스마트폰의 등장과 같은
  새로운 기술의 출현은 사람들이 더욱 많은 데이터를 만들고 소비하게 합니다.
  데이터는 이제 우리 일상을 채우는 공기 같은 존재가 되었습니다.
  `
};
